import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import { ThemeProvider } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import AOS from "aos";

import GlobalStyle from "~franchise-website/styles/globalStyles";
import getTheme from "~franchise-website/styles/theme";
import palettes from "~franchise-website/common/paletteTypes";

export const useDarkMode = () => {
	const [themeMode, setTheme] = useState("dark");
	const [paletteType, setPalette] = useState(palettes[0]);
	const [mountedComponent, setMountedComponent] = useState(false);

	const setMode = (mode) => {
		setTheme(mode);
	};

	const setThemePalette = (type = "orange") => {
		const palette = !palettes.includes(type) ? "orange" : type;
		setPalette(palette);
	};

	const themeToggler = () => {
		setMode("dark");
	};

	useEffect(() => {
		setMode("dark");
		setThemePalette("orange");
		setMountedComponent(true);
	}, []);

	return [
		themeMode,
		themeToggler,
		paletteType,
		setThemePalette,
		mountedComponent,
	];
};

export default function WithLayout({
	component: Component,
	layout: Layout,
	...rest
}) {
	React.useEffect(() => {
		// Remove the server-side injected CSS.
		const jssStyles = document.querySelector("#jss-server-side");
		if (jssStyles) {
			jssStyles.parentElement!.removeChild(jssStyles);
		}

		AOS.init({
			once: true,
			delay: 50,
			duration: 500,
			easing: "ease-in-out",
		});
	}, []);

	const [
		themeMode,
		themeToggler,
		paletteType,
		setThemePalette,
		mountedComponent,
	] = useDarkMode();

	useEffect(() => {
		AOS.refresh();
	}, [mountedComponent, themeMode, paletteType]);

	return (
		<ThemeProvider theme={getTheme(themeMode, paletteType)}>
			{/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
			<CssBaseline />
			<GlobalStyle />
			<Paper elevation={0}>
				<Layout
					themeMode={themeMode}
					themeToggler={themeToggler}
					paletteType={paletteType}
					setThemePalette={setThemePalette}>
					<Component
						themeMode={themeMode}
						paletteType={paletteType}
						{...rest}
					/>
				</Layout>
			</Paper>
		</ThemeProvider>
	);
}
